// ----- State -----
const initialState = {
  dismissedNotifications: [],
};

// ----- Types -----
// ADD DISMISSED NOTIFICATION
const ADD_DISMISSED_NOTIFICATION = "ADD_DISMISSED_NOTIFICATION";
const CLEAR_DISMISSED_NOTIFICATION = "CLEAR_DISMISSED_NOTIFICATION";

// ----- Reducer -----
export default function reducer(state = initialState, action) {
  switch (action.type) {
    // NOTIFICATIONS
    case ADD_DISMISSED_NOTIFICATION:
      return {
        ...state,
        dismissedNotifications: action.payload.newDismissedNotifications,
      };
    case CLEAR_DISMISSED_NOTIFICATION:
      return {
        ...state,
        dismissedNotifications: [],
      };
    default:
      return state;
  }
}

// ----- Actions -----
// ADD DISMISSED NOTIFICATION
export const addDismissedNotification =
  ({ newDismissedNotifications }) =>
  (dispatch) => {
    dispatch({
      type: ADD_DISMISSED_NOTIFICATION,
      payload: {
        newDismissedNotifications,
      },
    });
  };

export const clearDismissedNotifications = () => (dispatch) => {
  dispatch({ type: CLEAR_DISMISSED_NOTIFICATION });
};
